exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-7f9fb774],th[data-v-7f9fb774]{width:200px}tbody tr[data-v-7f9fb774]{cursor:pointer}", ""]);

// exports
